const memberAreaResources = {
    titleResignAgreementPopup: 'Resign Anytime Fitness Agreement',
    labelActionRequiredForMember: 'Action required: update withdrawal billing info',
    linkText: 'click here',
};
export default memberAreaResources;